import { withInstall } from '@xzx-design/utils'
import _Popover from './src/popover'

export const Popover = withInstall(_Popover)
export default Popover

export * from './src/popover'
export * from './src/types'
